import { render, staticRenderFns } from "./RechargeModal.vue?vue&type=template&id=64ae0a47&scoped=true"
import script from "./RechargeModal.vue?vue&type=script&lang=js"
export * from "./RechargeModal.vue?vue&type=script&lang=js"
import style0 from "./RechargeModal.vue?vue&type=style&index=0&id=64ae0a47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ae0a47",
  null
  
)

export default component.exports